import React from "react";
import { useNavigate } from 'react-router-dom';
import { ReactComponent as BookmarkIcon } from '../pages/assets/bookmark.svg';
import { ReactComponent as VerifiedIcon } from '../components/assets/verifiedicon.svg';
import emptyStar from './Review/assets/emptyStar.svg'
import fullStar from './Review/assets/fullStar.svg'


const renderStars = (rating) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} className="text-[#FEAD00] ">
        {i <= rating ? <img  src={fullStar} alt="fullStar" className='w-[13.33px] h-[12.69px] lg:w-[22.22px] lg:h-[21.15px]' /> :<img src={emptyStar} alt="emptyStar" className='w-[15.28px] h-[14.54px]' />}
      </span>
    );
  }
  return stars;
};





const SavedVendors = ({ savedVendorData, toggleSaveVendor, user, reviewData }) => {
  const navigate = useNavigate();

  const handleViewSavedVendorProfile = (vendorId) => {
    // Filter the savedVendorData for the clicked vendor
    const selectedVendor = savedVendorData.find(v => v.vendor_id === vendorId);
    if (!selectedVendor) return; // safety check

    // Filter reviews for this vendor
    const filteredVendorData = reviewData.filter(review => review.vendor.vendor_id === vendorId);

    navigate('/vendor', {
      state: {
        user: user,
        vendor: selectedVendor, // only the clicked saved vendor
        filteredVendorData: filteredVendorData
      }
    });
  };



  return (

    <div className="grid grid-cols-1 md:grid-cols-2  xl:grid-cols-3 gap-[10px] md:gap-5 lg:gap-4">

      {savedVendorData && savedVendorData.map((vendor) => {
        const avgRating =
          vendor.ratings && vendor.ratings.length > 0
            ? vendor.ratings.reduce((sum, r) => sum + r.rating_score, 0) /
            vendor.ratings.length
            : 0;


        return (


          <div
            key={vendor.vendor_id}
            className="flex items-center px-4 lg:px-8 pt-3 h-[114px] lg:h-[172px] border shadow-[10px_10px_40px_0px_#0000001A] border-[#c1c1c1]/50 rounded-[20px] bg-[#ffffff]"
          >
            {/* Vendor Avatar */}
            <div className="w-[39px] h-[39px] lg:w-[60px] lg:h-[60px] text-lg lg:text-xl -mt-7 rounded-full bg-[linear-gradient(136.03deg,#0052D4_13.41%,#65C7F7_100%)] text-white flex items-center justify-center font-bold mr-4 shrink-0">
              {(vendor?.vendor_name || '')
                .split(" ")
                .map((word) => word[0])
                .join("")}
            </div>

            {/* Vendor Info */}
            <div className="flex flex-col flex-1 justify-center">
              <div className="flex items-center space-x-2">
                <h3 className="font-bold text-lg lg:text-xl">{vendor.vendor_name}</h3>
                <VerifiedIcon className="w-6 h-6" />
              </div>
              <div className="flex justify-between">
                <div className="flex items-center  ">{renderStars(avgRating)}<span className="font-medium text-base lg:text-sm ml-2 ">{vendor?.category?.category_name}</span> </div>
                  {/* Bookmark Icon */}
                  <button onClick={() => toggleSaveVendor(vendor)} className="ml-4 shrink-0">

                    <BookmarkIcon className="w-7 h-7  lg:w-8 lg:h-8 fill-ravblue" />
                  </button>
              </div>

              <a
                onClick={() => handleViewSavedVendorProfile(vendor.vendor_id)}
                className="text-ravblue font-bold text-baselg:text-sm underline mt-1 inline-block cursor-pointer"
              >
                View profile
              </a>
            </div>



          </div>
        );
      })}
    </div>
  );
};

export default SavedVendors;
